import { FormattedMessage } from 'react-intl'

export const ReviewAddedView = () => (
  <div className='reviews__collapse-container'>
    <h3 className='reviews-collapse__title mbm'>
      <FormattedMessage
        defaultMessage='Thanks for your review!'
        id='reviews.dive_site.thanks_for_review'
      />
    </h3>
    <p className='reviews-collapse__subtitle'>
      <FormattedMessage
        defaultMessage='Your review will help fellow divers find the perfect dive site.'
        id='reviews.dive_site.review_will_help'
      />
    </p>
  </div>
)
